<template>
  <div v-show="showTaxes">
    <p v-for="(tax, index) of taxes" :key="index">
      <translate :tt="{ taxText: tax.name, taxRate: tax.rate }">
        {taxText} (exclusive) {taxRate, puNumber, style:percent
        minimumFractionDigits:3}
      </translate>
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class BookingExclusiveTaxes extends Vue {
  @Prop({ required: true })
  taxes: { name: string; rate: number }[]

  get showTaxes(): boolean {
    return this.taxes.length > 0
  }
}

export default toNative(BookingExclusiveTaxes)
</script>
